import React from 'react';
import styles from './shipCardList.module.sass';
import { SkeletonCard } from '../../../../Skeleton';
import { ShipCard } from '../ShipCard';

// Enum для типов круиза
export const CruiseType = {
  Rivers: 'rivers',
  Sea: 'sea',
};

export const ShipCardList = ({ cruises, type, isMobile, isLoading }) => (
  <>
    {!isLoading ? (
      <div className={styles.cardList}>
        {cruises?.map((i, index) => (
          <ShipCard
            position={index}
            shipInfo={i}
            key={i.id}
            title={i.name}
            type={type}
            url={i.url}
            countDesc={i.deck_count}
            cauta_count={i.cauta_count}
            seat_count={i.seat_of_the_ship}
            peoples_count={i.peoples_count}
            construction_date={i.construction_date}
            restoration_date={i.restoration_date}
            link={i.id}
            category={i.class}
            image={i.img}
            isMobile={isMobile}
          />
        ))}
      </div>
    ) : (
      <div className={styles.cardList}>
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
    )}
  </>
);
